import { render, staticRenderFns } from "./Whitepaper.vue?vue&type=template&id=1345d3fe&"
import script from "./Whitepaper.vue?vue&type=script&lang=js&"
export * from "./Whitepaper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports